/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const StocktakeReviewService = {

  async getStocktakeReviewBatches(code, itemCode) {
    const requestScreenData = {
      url: "api/StockBatchCommitted",
      filter: `StocktakeCode eq ${code} and ProductCode eq '${itemCode}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },

  async setLineExclude(payload) {
    var url = `api/Save_StocktakeExclude`;
    return await ApiService.post(url, payload);
  }
};

export { StocktakeReviewService };
